module.exports = __webpack_public_path__ + "img/ar_m_4.15879526.png";